import { useIntl } from 'react-intl';
import { Selector } from 'sonata-react-components';

import { groupingMessages } from '../groupingMessages';
import { firstOptionValue } from '../selectorOptions';

import type { CartographyLevel } from '../../domain/cartographyGrouping';

export interface CartographyLevelSelectorProps {
  /** CCA3 (upper case) of the selected items, used to translate the level names. */
  country: string;
  level: string | null;
  levels: CartographyLevel[];
  loading: boolean;
  onChange: (level: string | null) => void;
}

/** "Level" picker of the cartographic mode: labels from `adminBoundaries.boundaryType.<CCA3>_<level>`. */
export function CartographyLevelSelector({
  country,
  level,
  levels,
  loading,
  onChange
}: Readonly<CartographyLevelSelectorProps>) {
  const { formatMessage } = useIntl();
  const options = levels.map(({ id, name }) => ({
    id,
    label: formatMessage({ defaultMessage: name, id: `adminBoundaries.boundaryType.${country}_${id}` }),
    value: id
  }));

  return (
    <Selector
      id="newGroupModal-cartographyLevel"
      isDisabled={loading}
      label={formatMessage(groupingMessages.cartographyLevel)}
      onChange={selected => onChange(firstOptionValue(selected))}
      options={options}
      placeholder={formatMessage(
        loading ? groupingMessages.cartographyLevelLoading : groupingMessages.selectPlaceholder
      )}
      type="simple"
      value={options.filter(option => option.value === level)}
    />
  );
}
